import { Loader } from '@carsys/ui'
import Box from '@mui/material/Box'
import GSIOrderHandler from 'app/gsiOrderHandler/GSIOrderHandler'
import Feature from '@cbgms/base/feature-flags/Feature'
import React from 'react'
import { Route, Switch } from 'react-router-dom'
import lazyWithReload from 'utils/lazy-with-reload'
import Main from './Main'

const OnboardingContainer = lazyWithReload(() => import(/* webpackPrefetch: true */ 'app/auth/views/OnboardingContainer'))
const AuthContainer = lazyWithReload(() => import(/* webpackPrefetch: true */ 'app/auth/views/Container'))
const MyWorkorderContainer = lazyWithReload(() => import(/* webpackPrefetch: true */ 'app/myWorkorder/views/Container'))
const ActionRoutes = lazyWithReload(() => import(/* webpackPrefetch: true */ 'routes/action/ActionRoutes'))

const ApplicationRoutes = () => {
  return (
    <React.Suspense
      fallback={
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', justifyContent: 'center' }}>
          <Loader loading fading={false} />
        </Box>
      }
    >
      <Switch>
        <Route path='/gsi-order-handler' component={GSIOrderHandler} />
        <Route
          path='/bosch'
          render={() => {
            // Serve the bosch.html file
            window.location.href = '/bosch.html'
            return null
          }}
        />
        <Route
          path='/auth/onboarding'
          render={() => (
            <Feature feature='onboarding-redirect'>
              <OnboardingContainer />
            </Feature>
          )}
        />
        <Route path='/auth' component={AuthContainer} />
        <Route path='/my-workorder' component={MyWorkorderContainer} />
        <Route path='/action' component={ActionRoutes} />
        <Route path='/' component={Main} />
      </Switch>
    </React.Suspense>
  )
}

export default ApplicationRoutes
